import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from "redux-saga";
import reducers from './reducers';
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();

export function configureAppStore(initialState: any) {
    const store = configureStore({
        reducer: reducers,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
        preloadedState: initialState,
        devTools: false,
    });

    sagaMiddleware.run(rootSaga);
    return store;
}

